import { el } from "../lib/dom";

/**
 * Floating admin-panel link. Only rendered after `/bio-api/whoami` reports
 * `{ isAdmin: true }` — which itself only happens for IPs on the
 * `ADMIN_ALLOWED_IPS` allowlist. To anyone else, the admin entry point is
 * invisible and `/manage` returns 404 (or 302 → CF Access login for
 * anyone unauthenticated who knows the path).
 *
 * Placement is fixed-bottom-right so every template gets it for free.
 */
export async function mountAdminLinkIfAllowed(): Promise<void> {
  try {
    const r = await fetch("/bio-api/whoami", { cache: "no-store" });
    if (!r.ok) return;
    const data = (await r.json()) as { isAdmin?: boolean };
    if (!data.isAdmin) return;
  } catch {
    return;
  }

  const link = el("a", {
    class: "admin-link",
    href: "/manage",
    "data-tooltip": "Admin panel",
    "aria-label": "Admin panel",
  }, [
    // Gear / cog icon.
    (() => {
      const SVG_NS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(SVG_NS, "svg");
      svg.setAttribute("viewBox", "0 0 24 24");
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("fill", "currentColor");
      const path = document.createElementNS(SVG_NS, "path");
      path.setAttribute(
        "d",
        "M19.14 12.94a7.49 7.49 0 0 0 .05-.94 7.49 7.49 0 0 0-.05-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.61-.22l-2.39.96a7.03 7.03 0 0 0-1.62-.94l-.36-2.54A.5.5 0 0 0 14 2h-4a.5.5 0 0 0-.49.42l-.36 2.54c-.58.24-1.12.56-1.62.94l-2.39-.96a.5.5 0 0 0-.61.22L2.61 8.48a.5.5 0 0 0 .12.64L4.76 10.7c-.03.31-.05.62-.05.94s.02.63.05.94L2.73 14.16a.5.5 0 0 0-.12.64l1.92 3.32c.14.24.43.33.67.22l2.39-.96c.5.38 1.04.7 1.62.94l.36 2.54c.04.25.25.42.49.42h4c.25 0 .45-.17.49-.42l.36-2.54c.58-.24 1.12-.56 1.62-.94l2.39.96c.24.1.53 0 .67-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58ZM12 15.5A3.5 3.5 0 1 1 12 8.5a3.5 3.5 0 0 1 0 7Z",
      );
      svg.append(path);
      return svg;
    })(),
  ]);
  document.body.append(link);
}
